export default "__VITE_ASSET__Cfm$9tGU__"